import * as React from "react";
import { FacetsView } from "@tlc/ls2pac/app/views/results/FacetsView";
import { Box, SxProps, Theme } from "@mui/material";
import { useLanguage } from "./Language";

interface FacetViewWrapperProps {
  sx?: SxProps<Theme>;
}

export const FacetViewWrapper: React.FC<FacetViewWrapperProps> = ({ sx }) => {
  const { translate } = useLanguage();
  React.useEffect(() => {
    const facetView = new FacetsView();
    return () => {
      facetView.removeListeners();
    };
  }, []);

  return (
    <Box
      sx={{
        ...sx,
      }}
    >
      <div id="breadCrumbsContainer" style={{ display: "none" }}>
        <h3>{translate("filteredBy")}</h3>
        <ul id="facetBreadCrumbs"></ul>
      </div>
      <div id="facetsContainer">
        <ul id="facets">
          <li>&nbsp;</li>
        </ul>
      </div>
    </Box>
  );
};
